<p-badge [value]="value" [size]="size" [severity]="severity"></p-badge>